import { render, staticRenderFns } from "./InviteMembersModal.vue?vue&type=template&id=6a12d5ca&scoped=true"
import script from "./InviteMembersModal.vue?vue&type=script&lang=js"
export * from "./InviteMembersModal.vue?vue&type=script&lang=js"
import style0 from "./InviteMembersModal.vue?vue&type=style&index=0&id=6a12d5ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12d5ca",
  null
  
)

export default component.exports